<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Casos asignados a liquidador sin informe de liquidación</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>
          <b-row>
            <b-col sm="3">
              <b-form-group label="Tipo de Fecha">
                <b-form-radio-group v-model="datosFormulario.selected" @input="cambiarFechas">
                  <b-form-radio v-model="datosFormulario.selected" name="some-radios" value="A">Fecha Aviso Impago</b-form-radio>
                  <b-form-radio v-model="datosFormulario.selected" name="some-radios" value="I">Fecha Ingreso</b-form-radio>
                  <b-form-radio v-model="datosFormulario.selected" name="some-radios" value="X">Automático</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group :label="crearLabel('Fecha Desde', 'fdesde', 'datosFormulario')"
                          label-for="fdesde" :horizontal="false" v-show="mostrarFechas">
                  <b-input-group>
                      <div class="input-group-prepend">
                          <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                      </div>
                      <datepicker 
                          :language="es" 
                          format="dd/MM/yyyy"
                          :use-utc="true"
                          input-class="form-control" 
                          v-model="datosFormulario.fdesde"
                          :disabled="campoBloqueado('fdesde', 'datosFormulario')">
                      </datepicker>
                  <span class="error-validacion-campo">
                      {{ mensajeValidacionCampo.fdesde }}
                  </span>
                  </b-input-group>
              </b-form-group>    

              <b-form-group
                :label="crearLabel('Productos', 'productos', 'datosFormulario')"
                label-for="productos">
                <b-form-select 
                  :options="valProductos"  
                  v-model="datosFormulario.productos"
                  :disabled="campoBloqueado('productos', 'datosFormulario')"
                >
                </b-form-select>
                
                <span class="error-validacion-campo">
                  {{ mensajeValidacionCampo.codejecutivo }}
                </span>
              </b-form-group>
            </b-col>

            <b-col sm="3">  
              <b-form-group :label="crearLabel('Fecha Hasta', 'fhasta', 'datosFormulario')"
                          label-for="fhasta" :horizontal="false" v-show="mostrarFechas">
                  <b-input-group>
                      <div class="input-group-prepend">
                          <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                      </div>
                      <datepicker 
                          :language="es" 
                          format="dd/MM/yyyy"
                          :use-utc="true"
                          input-class="form-control" 
                          v-model="datosFormulario.fhasta"
                          :disabled="campoBloqueado('fhasta', 'datosFormulario')">
                      </datepicker>
                  <span class="error-validacion-campo">
                      {{ mensajeValidacionCampo.fhasta }}
                  </span>
                  </b-input-group>
              </b-form-group>    

              <b-form-group
                :label="crearLabel('Origen Prórroga', 'origenpro', 'datosFormulario')"
                label-for="origenpro">
                <b-form-select 
                  :options="valOrigen"  
                  v-model="datosFormulario.origenpro"
                  :disabled="campoBloqueado('origenpro', 'datosFormulario')"
                >
                </b-form-select>
                
                <span class="error-validacion-campo">
                  {{ mensajeValidacionCampo.origenpro }}
                </span>
              </b-form-group>
            </b-col>

            <b-col sm="2">
                <b-form-group
                  :label="crearLabel('Ejecutivo', 'codejecutivo', 'datosFormulario')"
                  label-for="codejecutivo">
                  <b-form-select 
                    :options="valEjecutivos"  
                    v-model="datosFormulario.codejecutivo"
                    :disabled="campoBloqueado('codejecutivo', 'datosFormulario')"
                  >
                  </b-form-select>
                  
                  <span class="error-validacion-campo">
                    {{ mensajeValidacionCampo.codejecutivo }}
                  </span>
                </b-form-group>
            </b-col>

            
          </b-row>

          <div slot="footer">
                <div class="form-actions">
                    <el-row>
                            <el-col>
                                <b-button variant="primary" @click="buscar"><i class="fa fa-search"></i> Consultar</b-button>
                                <b-button variant="primary" @click="pre_insertar"><i class="fa fa-eraser"></i> Limpiar</b-button>
                                <b-button variant="primary" @click="descargarExcel"><i class="fa fa-file-excel-o"></i> Exportar</b-button>
                            </el-col> 
                               
                    </el-row>                
                </div>
            </div>            
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Casos asignados a liquidador sin informe de liquidación</strong>
          </div>
          <b-row>
            <b-col lg="6">
              
            </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
              <data-tables ref="refTable1"
                :data="data"
                name="table"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titles"
                  :prop="title.prop"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  :min-width="title.minwidth"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                
              </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>

      
      </b-col>
    </b-row>
    
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiInformes from "@/components/services/apiInformes";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";

import XLSX from "xlsx";

export default {
  name: "CasosAsignadosLiquidadorSinInformeLiquidacion",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },

      data: [],
      nombreexcel: "CasosAsignadosLiquidadorSinInformeLiquidacion",
      //titlesDinamic: [],
      titles: [
        {
          prop: "Ejecutivos",
          label: "Ejecutivos",
          align: "left",
          minwidth:'230'
        },
        {
          prop: "1221 (Viollier)",
          label: "1221 (Viollier)",
          align: "right",
          minwidth:'200'
        },
        {
          prop: "1214 (Charles Taylor)",
          label: "1214 (Charles Taylor)",
          align: "right",
          minwidth:'200'
        },
        {
          prop: "639198 (Waisman)",
          label: "639198 (Waisman)",
          align: "right",
          minwidth:'200'
        },
        {
          prop: "1210 (directo)",
          label: "1210 (directo)",
          align: "right",
          minwidth:'200'
        },
        {
          prop: "Total",
          label: "Total",
          align: "right",
          minwidth:'200'
        },
        {
          prop: "Monto Promedio (Pesos)",
          label: "Monto Promedio (MM$)",
          align: "right",
          minwidth:'200'
        },
        {
          prop: "Tiempo Promedio (Días)",
          label: "Tiempo Promedio (Días)",
          align: "right",
          minwidth:'200'
        }
      ],
      filters: [
        {
          prop: ["Ejecutivos",
                 "1221 (Viollier)",
                 "1214 (Charles Taylor)",
                 "639198 (Waisman)",
                 "1210 (directo)",
                 "Total",
                 "Monto Promedio (Pesos)",
                 "Tiempo Promedio (Días)"
                 ],
          value: ""
        }
      ],


      datosFormulario: {},
      valEjecutivos: [],
      valProductos: [],
      valOrigen: [],
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},
      mostrarFechas: true,

      tableProps2:{
          summaryMethod: this.totales,
          showSummary: false,
          maxHeight: 400
      },
    };
  },
  components:{
    Datepicker
  },
  methods: {

    cambiarFechas(){
      if(this.datosFormulario.selected == 'X') {
            this.mostrarFechas = false;
      }else{
            this.mostrarFechas = true;
      }
    },

    formatNumber(n) {
      console.log(n);
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

    totales(param) {
 
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
          if (index === 0) {
              sums[index] = 'Total';
              return;
          }

          const values = data.map(item => Number(item[column.property]));

          if (!values.every(value => isNaN(value))) {
              sums[index] = this.$numeral((values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0))).format();
             /*
             sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0);
              */
          } else {
              sums[index] = '';
          }
      });

      return sums;
    },

    exportarExcel() {
        this.$nextTick(function() {
          var tabla = document.getElementById("tableExcel");
          var data = XLSX.utils.table_to_sheet(tabla);
          const workbook = XLSX.utils.book_new();
          const filename = "Export";
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        });
    },
    
    pre_insertar() {
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];

      return apiInformes
        .pre_insercion_casos_asig_liq(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }
          
          var lista_data = response.data.res;
          for(var i = 0; i < lista_data.length; i++){
              this.datosFormulario.codejecutivo = lista_data[i]["codejecutivo"];
              this.datosFormulario.origenpro = lista_data[i]["origenpro"];
              this.datosFormulario.selected = lista_data[i]["selected"];
              this.datosFormulario.fdesde = lista_data[i]["fdesde"];
              this.datosFormulario.fhasta = lista_data[i]["fhasta"];
              this.datosFormulario.productos = lista_data[i]["productos"];
          }
         
      
          this.datosFormularioEstado = response.data.festado;
          
          //Carga lista de ejecutivos
          var tiposEjecutivos = new Array();
          var lista_tipos_ejecutivos = response.data.ejecutivos;
          for(var i = 0; i < lista_tipos_ejecutivos.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_ejecutivos[i]["codejecutivo"];
              obj.text = lista_tipos_ejecutivos[i]["des_ejecutivo"];
              tiposEjecutivos.push(obj);
          }
          this.valEjecutivos = tiposEjecutivos;

          //Carga lista de productos
          var tiposProductos = new Array();
          var lista_tipos_productos = response.data.productos;
          for(var i = 0; i < lista_tipos_productos.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_productos[i]["productos"];
              obj.text = lista_tipos_productos[i]["desc_productos"];
              tiposProductos.push(obj);
          }
          this.valProductos = tiposProductos;

          //Carga lista de origen
          var tiposOrigen = new Array();
          var lista_tipos_origen = response.data.origenpro;
          for(var i = 0; i < lista_tipos_origen.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_origen[i]["origenpro"];
              obj.text = lista_tipos_origen[i]["desc_origenpro"];
              tiposOrigen.push(obj);
          }
          this.valOrigen = tiposOrigen;
          
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscar() {
      this.$Progress.start();

      return apiInformes
        .CasosAsignadosaLiquidadorsinInformedeLiquidacion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.selected,
          this.datosFormulario.fdesde, 
          this.datosFormulario.fhasta, 
          this.datosFormulario.codejecutivo,
          this.datosFormulario.productos,
          this.datosFormulario.origenpro
        )
        .then(response => {
          this.data  = response.data.res1;
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();
          
          if (this.data != null){
            this.exportar = true;
          } else {
            this.exportar = false;
          }

          
          
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    formatter(row, column) {
      if ((column.property == "Fecha de asignación" || column.property == "Fecha término") && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      }
      else if (column.property != "Ejecutivos" && row[column.property]){
        //column.align = "is-right";
        return this.$numeral(row[column.property]).format();
      }
      else {
        return row[column.property];
      }
    },

    descargarExcel: function(){
      var cuerpo = "";
      var columnas = this.titles;

      var xl159618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo += "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
        cuerpo += "<td height=28 class=xl159618 width=32 style='height:21.0pt;width:24pt;"+xl159618+"'></td>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 width=698 style='width:526pt;"+xl689618+"'>Casos asignados a liquidador sin informe de liquidación</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
        cuerpo += "<td height=28 class=xl159618 style='height:21.0pt;"+xl159618+"'></td>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 style='border-right:.5pt solid black;"+xl689618+"' >Desde "+this.convierteFecha(this.datosFormulario.fdesde)+" Hasta "+this.convierteFecha(this.datosFormulario.fhasta)+"</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
        for (var i=0; i<columnas.length; i++) {
          cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>"+columnas[i].label+"</td>\n";
        }
      cuerpo += "</tr>\n";


      //Data bloque 1
      for (var key in this.data) {
          if(this.data[key]["1221 (Viollier)"] == undefined){
              this.data[key]["1221 (Viollier)"] = "";
          }
          if(this.data[key]["1214 (Charles Taylor)"] == undefined){
              this.data[key]["1214 (Charles Taylor)"] = "";
          }
          if(this.data[key]["639198 (Waisman)"] == undefined){
              this.data[key]["639198 (Waisman)"] = "";
          }
          if(this.data[key]["1210 (directo)"] == undefined){
              this.data[key]["1210 (directo)"] = "";
          }
          if(this.data[key]["Monto Promedio (Pesos)"] == undefined){
              this.data[key]["Monto Promedio (Pesos)"] = "";
          }
          if(this.data[key]["Tiempo Promedio (Días)"] == undefined){
              this.data[key]["Tiempo Promedio (Días)"] = "";
          }

          cuerpo += "<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
            cuerpo += "<td>&nbsp</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Ejecutivos"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["1221 (Viollier)"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["1214 (Charles Taylor)"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["639198 (Waisman)"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["1210 (directo)"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Total"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Monto Promedio (Pesos)"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Tiempo Promedio (Días)"]+"</td>\n";
          cuerpo += "</tr>\n";
      }

      this.export(this.generaExcelV2(this.nombreexcel, cuerpo),this.nombreexcel);
    },

    export:async function(data, filename) {
      if(typeof this.beforeFinish === 'function')
        await this.beforeFinish();
      download(data, filename,  "application/vnd.ms-excel");
    },
    
    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },
  },
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
    this.buscar();
  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};
</script>
